<template>
  <div class="pb-30">
    <ContentSection skew="right" id="products" class="z-0 bg-grimacepurple-600 pb-10 pt-16 pb-20">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-10">
          <h1 class="text-4xl text-white">Pipefish products</h1>
          <p class="pb-2 text-xl sm:text-2xl font-light text-white">
            Find out what we've been up to in the product development space.
          </p>
        </div>
      </div>
    </ContentSection>

    <ContentSection skew="right" id="products" class="z-0 bg-grey-100 pb-10 my-0 pt-20 pb-32 -mb-8">
      <router-link
        style="text-decoration: none; color: inherit;"
        class="item card shadow"
        v-for="item in Store.products"
        v-bind:key="item.slug"
        :to="{ name: 'product', params: { product: item.slug } }"
        :class="{
          blue: item.color === 'blue',
          darkblue: item.color === 'darkblue',
          red: item.color === 'red',
          orange: item.color === 'orange',
          green: item.color === 'green',
          purple: item.color === 'purple',
          brown: item.color === 'brown'
        }"
      >
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12 md:col-span-2 relative">
            <svgicon
              class="pf-logo product-image  sm:ml-auto sm:mr-auto  ml-0 mr-0"
              name="pipefish-logo-on-light"
            />
          </div>
          <div class="col-span-10 md:col-span-9">
            <h3 class="heading-three my-2" style="margin: revert">{{ item.name }}</h3>
            <div class="copy-md">
              {{ item.description }}
            </div>
            <a
              href="/products/CISynchronizer"
              class="button button--primary button--sm font-bold mt-3 text-white inline-block no-underline"
              title="Learn more about, or downlaod the Lansweeper to ServiceNow CI Synchronizer"
            >
              Learn more
            </a>
          </div>
        </div>

        <!-- <div class="product">
          <div class="product-image">
            <svgicon class="pf-logo" name="pipefish-logo-on-light" width="5rem" height="5rem" />
          </div>

          <div class="product-content">
            <h3 class="heading-three" style="margin: revert">{{ item.name }}</h3>
            <div class="product-description">
              <span class="copy-md" v-html="item.description" />
            </div>
          </div>
        </div> -->
      </router-link>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/ContentSection.vue';
export default {
  name: 'ProductsIndex',
  components: {
    ContentSection
  },
  props: ['standalone'],
  data: function() {
    return {
      isStandalone: this.standalone
    };
  },
  methods: {}
};
</script>

<style lang="scss">
@mixin caseStudyTheme($primary) {
  .case {
    .no {
      color: rgba($primary, 0.3);
    }
    .name a,
    .name span {
      color: $primary;
    }
    &:hover {
      background: darken($primary, 10%);
      .no,
      .name a,
      .name span {
        color: #fff;
      }
    }
  }
}

.product {
  display: flex;
  flex-shrink: 0;
  min-height: 50px;
  // margin-top: 2rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  background: #fff;
  padding: 10px 0px 15px 0px;

  @include media('<medium') {
    display: block;
    text-align: center;
  }
}

.product-image {
  max-width: 80px;
  // position: absolute;
  // left: 50%;
  // top: 1.25rem;
  // transform: translateX(-50%);

  // width: 6rem;
  // height: 6rem;
  // margin: 1.25rem;
  // flex-shrink: 0;

  // @include media('<medium') {
  //   margin-left: auto;
  //   margin-right: auto;
  // }
  // // background: red;
}

.product-content {
  height: 100%;
}

.product-description {
  width: 95%;
  @include media('<medium') {
    margin-left: auto;
    margin-right: auto;
  }
}

.sect--product {
  margin: 0 0 -50px 0;
  padding: 50px 0 150px 0;
  background: $Grey1WhiteSmoke;
  transform: skewY($skew);
  > .inner {
    transform: skewY($-skew);
  }
  &.standalone {
    margin-top: 70px;
    padding-top: 10px;
    margin-bottom: 80px;
    padding-bottom: 100px;
    .inner {
      // margin-top: 20px;
    }
  }
}

.product-grid {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: center;
  margin: 20px 0 0 0;
  a.item,
  div.item {
    width: 100%;
    cursor: pointer !important;
    @include media('>500px') {
      width: 100%;
    }

    .case {
      @include rtp_transition($property: 'transform', $duration: 0.3s);
      position: relative;
      margin: 3px;
      height: 110px;
      background: #fff;
      border-radius: 2px;
      cursor: pointer !important;
      @include media('>=450px') {
        height: 125px;
      }
      &:hover {
        background: darken($CaseStudyBlue, 10%);
        box-shadow: 0px 2px 7px 0 rgba(102, 102, 102, 0.2);
        .no,
        .name a,
        .name span {
          color: #fff;
        }
        .name a,
        .name span {
          text-decoration: underline;
        }
      }

      .no {
        font-family: $brand-font-family;
        font-size: 50px;
        position: absolute;
        left: 0px;
        top: 0px;
        font-weight: 800;
        z-index: 10;
        color: rgba($CaseStudyBlue, 0.3);
        padding: 0 0 0 15px;
        @include media('>=medium') {
          padding: 5px 0 0 25px;
        }
      }
      .name {
        @include rtp_transition($duration: 0.55s);
        position: absolute;
        z-index: 15;
        top: auto;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 0px 10px 10px 15px;
        color: $CaseStudyBlue;
        // color: #fff !important;
        cursor: pointer;
        @include media('>=medium') {
          // top: 55px;
          padding: 10px 25px 15px 25px;
        }
        a,
        span {
          color: $CaseStudyBlue;
          font-family: $brand-font-family;
          font-size: 19px;
          font-weight: 400;
          line-height: 1.2em;
          text-decoration: none;
          @include media('>500px') {
            font-size: 17px;
          }
          @include media('>800px') {
            font-size: 19px;
          }
        }
      }
    }
    &.blue {
      @include caseStudyTheme($CaseStudyBlue);
    }
    &.darkblue {
      @include caseStudyTheme($CaseStudyDarkBlue);
    }
    &.red {
      @include caseStudyTheme($CaseStudyRed);
    }
    &.orange {
      @include caseStudyTheme($CaseStudyOrange);
    }
    &.green {
      @include caseStudyTheme($CaseStudyGreen);
    }
    &.purple {
      @include caseStudyTheme($CaseStudyPurple);
    }
    &.brown {
      @include caseStudyTheme($CaseStudyBrown);
    }
  }
}
</style>
